"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var moment = require("moment");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var ResponsiveResizeComponent_1 = require("../base/ResponsiveResizeComponent");
var calendar_1 = require("../calendar");
var icon_1 = require("../icon");
var react_transition_group_1 = require("react-transition-group");
var DatePicker = /** @class */ (function (_super) {
    tslib_1.__extends(DatePicker, _super);
    function DatePicker(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onWindowScroll = function () {
            if (_this.state.isOpen) {
                _this.setPosition();
            }
        };
        _this.onDocumentClick = function (e) {
            var isOpen = _this.state.isOpen;
            if (_this.isClickOutside(e.target) && isOpen) {
                _this.setState({
                    isOpen: false
                });
            }
        };
        _this.onClick = function (e) {
            if (_this.props.disabled || !_this.$el.contains(e.target) || (_this.$calendar && _this.$calendar.contains(e.target))) {
                return;
            }
            var nextState = {
                isOpen: !_this.state.isOpen
            };
            _this.setState(nextState);
        };
        _this.onChange = function (date) {
            var onChange = _this.props.onChange;
            onChange && onChange(date);
            _this.setState(function (prevState) {
                if (prevState.isOpen) {
                    return { isOpen: false };
                }
                return null;
            });
        };
        _this.setRef = function (el) {
            _this.$el = el;
        };
        _this.setCalendarRef = function (el) {
            _this.$calendar = el;
        };
        _this.$el = null;
        _this.$calendar = null;
        _this.state = { isOpen: false, verticalPositionCssProp: "top", horizontalPositionCssProp: "left" };
        return _this;
    }
    DatePicker.prototype.getMouseEventMap = function () {
        return {
            click: this.onDocumentClick
        };
    };
    DatePicker.prototype.componentDidResize = function (e) {
        if (this.state.isOpen) {
            this.setPosition();
        }
    };
    DatePicker.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        utils_1.addEventsToDocument(this.getMouseEventMap());
        window.addEventListener("scroll", this.onWindowScroll, { passive: true });
    };
    DatePicker.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        utils_1.removeEventsFromDocument(this.getMouseEventMap());
        window.removeEventListener("scroll", this.onWindowScroll, { passive: true });
    };
    DatePicker.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.isOpen && !prevState.isOpen) {
            this.setPosition();
        }
    };
    DatePicker.prototype.isClickOutside = function (target) {
        return !this.$el.contains(target) && (!this.$calendar ? true : !this.$calendar.contains(target));
    };
    DatePicker.prototype.setPosition = function () {
        var _this = this;
        utils_1.raf(function () {
            var horizontalPositionCssProp = "left", verticalPositionCssProp = "top";
            if (_this.$calendar) {
                var pickerRect = _this.$el.getBoundingClientRect();
                var calendarRect = _this.$calendar.getBoundingClientRect();
                if (window.pageYOffset + window.innerHeight < pickerRect.top + window.pageYOffset + pickerRect.height + calendarRect.height) {
                    verticalPositionCssProp = "bottom";
                }
                if (pickerRect.left + calendarRect.width > window.pageXOffset + window.innerWidth) {
                    horizontalPositionCssProp = "right";
                }
            }
            if (horizontalPositionCssProp !== _this.state.horizontalPositionCssProp ||
                verticalPositionCssProp !== _this.state.verticalPositionCssProp) {
                _this.setState({
                    verticalPositionCssProp: verticalPositionCssProp,
                    horizontalPositionCssProp: horizontalPositionCssProp
                });
            }
        });
    };
    DatePicker.prototype.renderCalendar = function () {
        var _a;
        var _b = this.state, verticalPositionCssProp = _b.verticalPositionCssProp, horizontalPositionCssProp = _b.horizontalPositionCssProp;
        var _c = this.props, theme = _c.theme, date = _c.date, minDate = _c.minDate, maxDate = _c.maxDate, enablePassiveDay = _c.enablePassiveDay;
        var wrapperStyles = (_a = {},
            _a[verticalPositionCssProp] = "100%",
            _a[horizontalPositionCssProp] = 0,
            _a);
        return (React.createElement("div", { className: theme.calendar, style: wrapperStyles, ref: this.setCalendarRef },
            React.createElement(calendar_1.default, { date: date, enablePassiveDay: enablePassiveDay, minDate: minDate, maxDate: maxDate, onChange: this.onChange })));
    };
    DatePicker.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, className = _b.className, date = _b.date, minDate = _b.minDate, format = _b.format, placeholder = _b.placeholder, onChange = _b.onChange, fill = _b.fill, small = _b.small, disabled = _b.disabled, others = tslib_1.__rest(_b, ["theme", "className", "date", "minDate", "format", "placeholder", "onChange", "fill", "small", "disabled"]);
        var isOpen = this.state.isOpen;
        var classes = classnames_1.default(theme.picker, className, (_a = {},
            _a[theme.focus] = isOpen,
            _a[theme.fill] = fill,
            _a[theme.small] = small,
            _a[theme.disabled] = disabled,
            _a));
        return (React.createElement("div", { className: classes, ref: this.setRef, onClick: this.onClick },
            React.createElement("div", { className: theme.inner },
                !date
                    ? React.createElement("div", { className: theme.placeholder }, placeholder || format || "\u00A0")
                    : React.createElement("div", { className: theme.value }, moment(date).format(format)),
                React.createElement(icon_1.default, { className: theme.icon, size: 2, iconName: "icon-calendar" })),
            React.createElement(react_transition_group_1.CSSTransition, { in: isOpen, unmountOnExit: true, classNames: {
                    enter: theme.calendarEnter,
                    enterActive: theme.calendarEnterActive,
                    exit: theme.calendarLeave,
                    exitActive: theme.calendarLeaveActive
                }, timeout: 200 }, this.renderCalendar())));
    };
    DatePicker.defaultProps = {
        date: null,
        minDate: null,
        maxDate: null,
        format: "DD/MM/YYYY",
        disabled: false
    };
    return DatePicker;
}(ResponsiveResizeComponent_1.default));
exports.default = DatePicker;
